import validate from "/usr/src/app/content/n3-spas-020be917-fd92-4333-b155-b7cff6266aa7/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-020be917-fd92-4333-b155-b7cff6266aa7/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}